import { APIDataBlueUser, APIDataThread, APIMetaDataThreadPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

export interface DisplayThread extends APIDataThread {
    userIds?: number[]
    name: string
    isBotThread: boolean
    // true when the current user has closed (hidden) this thread
    // (ThreadUserThrough.isEnabled=false server-side). undefined = unknown
    isClosed?: boolean
}

class ThreadStore extends Store<DisplayThread> {
    constructor() {
        super([...APIMetaDataThreadPropertyNames, 'userIds', 'users', 'name', 'isBotThread', 'isClosed'])
    }
}

decorate(injectable(), ThreadStore)

export { ThreadStore }
